import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=7dedadad"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports